var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.88 14.5385H19.76V4.93848C19.76 2.69848 18.5467 2.24514 17.0667 3.92514L16 5.13848L6.97335 15.4051C5.73335 16.8051 6.25335 17.9518 8.12002 17.9518H12.24V27.5518C12.24 29.7918 13.4533 30.2451 14.9333 28.5651L16 27.3518L25.0267 17.0851C26.2667 15.6851 25.7467 14.5385 23.88 14.5385Z",
    fill: "#14904A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.376d20b9c4bd1957f92eb46014990102.svg";
export { ForwardRef as ReactComponent };